module.exports = __webpack_public_path__ + "media/images/application/template/helifix-ancon-7a13af43b7a492977f4584525a12acf3.png";